const formData = {
  formId: 'marinerProfileForm',
  formField: {
    firstName: {
      name: 'firstName',
      label: 'First Name',
      requiredErrorMessage: 'First Name is required.'
    },
    middleName: {
      name: 'middleName',
      label: 'Middle Name',
    },
    lastName: {
      name: 'lastName',
      label: 'Last Name',
      requiredErrorMessage: 'Last Name is required.'
    },
    mmcId: {
      name: 'mmcId',
      label: 'MMC ID',
      requiredErrorMessage: 'MMC ID is required.'
    },
    dateOfBirth: {
      name: 'dateOfBirth',
      label: 'Date Of Birth',
      requiredErrorMessage: 'Date Of Birth is required.'
    },
    gender: {
      name: 'gender',
      label: 'Gender',
    },
    rating: {
      name: 'rating',
      label: 'Rating',
      requiredErrorMessage: 'Rating is required.'
    },
    type: {
      name: 'type',
      label: 'Rating Type',
    },
    status: {
      name: 'status',
      label: 'Mariner Status',
    },
    agentUnion: {
      name: 'agentUnion',
      label: 'Mariner Union/Agency',
    },
    twicTsaNum: {
      name: 'twicTsaNum',
      label: 'TWIC/TSA Number',
      requiredErrorMessage: 'TWIC/TSA Number is required.'
    },
    phone: {
      name: 'phone',
      label: 'Phone',
      requiredErrorMessage: 'Phone is required.'
    },
    email: {
      name: 'email',
      label: 'Email',
      requiredErrorMessage: 'Email is required.',
      validErrorMessage: 'Provide a valid email.'
    },
    placeOfBirth: {
      name: 'placeOfBirth',
      label: 'Place of Birth',
    },
    seniority: {
      name: 'seniority',
      label: 'SIU Seniority'
    },
    veteran: {
      name: 'veteran',
      label: 'Are you a Military Veteran?'
    },
    trainingStatus: {
      name: 'trainingStatus',
      label: 'Training Status'
    },
    vessel: {
      name: 'vessel',
      label: 'Vessel'
    }
  }
};

export default formData;